import React from 'react';
import { formatCurrency } from '@futurefamily/ef-utils';
import styled from 'styled-components';
import { usePropagateTreatmentFormValues, Select, SelectExtras } from '@futurefamily/ef-components';
import { treatments } from 'constants/treatments';

const MSelect = styled(Select)`
  ${SelectExtras.SelectWrapper} {
    border: 0px;
  }

  ${SelectExtras.Field} {
    background: rgba(133, 194, 197, 0.3);
    border-radius: 40px;
    border: 0px;
    font-size: 16px;
    text-align: center;
    text-align-last: center;
    font-weight: 600;
    line-height: 25px;
  }
`

function TreatmentSelect (props) {
  usePropagateTreatmentFormValues(treatments);

  return (
    <MSelect
      name="treatment"
      label="What treatment are you interested in?"
      {...props}
    >
      <option value="">Select one</option>
      {treatments.map(treatment => (
        <option key={treatment.value} value={treatment.value}>{treatment.name} ${formatCurrency(treatment.cost)}</option>
      ))}
    </MSelect>
  );
}

export default TreatmentSelect;
